import { Role } from './roles-enum';

import { IProductVariant } from '@/interfaces/api/product/IProduct';

const role = Role.ASSISTANT;

enum contents {
	WELCOME = 'Hi there! Warmest welcome to our haggling session! I am here to help you with your purchase.',
	VARIANT_INFO = 'You have selected the variant: {{variant.title}}',
	ASK_FOR_OFFER = 'Okay, now tell me how many units of this product you are interested in purchasing and the price you are willing to offer',
	NO_VARIANT_INFO = 'The variant has no options.',
}

export const initialMessages = {
	Welcome: {
		role,
		content: contents.WELCOME,
	},
	VariantInfo: (title: string) => ({
		role,
		content: title
			? contents.VARIANT_INFO.replace('{{variant.title}}', title)
			: contents.NO_VARIANT_INFO,
	}),
	AskForOffer: {
		role,
		content: contents.ASK_FOR_OFFER,
	},
};

export const formatIntroMessage = (message: string) => {
	return message
		.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
		.replace(/\n\n/g, '<br/><br/>')
		.replace(/\n/g, '<br/>');
};

export const options = ['Marketing', 'Sales', 'Support'];

export const typingMessages = [
	'Thinking...',
	'Just a moment!',
	'One Sec...',
	'Cooking up something good...',
	'Hold tight...',
	'Scanning the option...',
	'Balancing the scales...',
	'Crunching some thoughts...',
	'Interesting...',
	'Haggling...',
	"Okay, Let's see...",
	'Here is a thought...',
	'Hmmm...',
];

export const getRandomMessage = () => {
	return typingMessages[Math.floor(Math.random() * typingMessages.length)];
};

// Format title with labels from type field and option values
export const formatVariantTitle = (
	variant: IProductVariant,
	productOptions?: Array<{ name: string; position: number }>,
) => {
	// FOR SHOPIFY PRODUCTS: If we have product options, use them to create the formatted title
	if (productOptions) {
		const optionValues = [
			variant.option1,
			variant.option2,
			variant.option3,
		].filter(Boolean);

		if (optionValues.length > 0) {
			return productOptions
				.slice(0, optionValues.length)
				.map((option, index) => `${option.name}: ${optionValues[index]}`)
				.join('; ');
		}
	}

	// FOR CSV PRODUCTS: Fallback to original logic for backwards compatibility
	if (!variant.type) return variant.title;

	const labels = variant.type.split(' - ');
	const options = [variant.option1, variant.option2, variant.option3].filter(
		Boolean,
	);

	if (labels.length !== options.length) return variant.title;

	return labels.map((label, index) => `${label}: ${options[index]}`).join('; ');
};
